import {
  FC,
  ReactNode,
  useEffect,
  useState,
  createContext,
  useContext,
} from "react";
import { IAuthUser, IAuthContextType } from "interfaces/auth";
import { auth, db } from "connections/firebase";
import { Navigate, useLocation } from "react-router-dom";
import FullPageSpinner from "./FullPageSpinner";
import { doc, getDoc } from "firebase/firestore";
import { IAdmin } from "interfaces/admin";

const AuthContext = createContext<IAuthContextType>({
  user: null,
  setUser: (user) => {},
});

const AuthProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<IAuthUser | null>(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        const { displayName, email, photoURL, uid } = user;
        const snapshot = await getDoc(doc(db, "admins", uid));
        const adminData = snapshot.data() as IAdmin;

        setUser({
          name: displayName as string,
          email: email as string,
          avatar: photoURL as string,
          role: adminData.role,
        });
        setLoading(false);
      } else {
        setUser(null);
        setLoading(false);
      }
    });
  }, []);

  if (isLoading) {
    return <FullPageSpinner />;
  }

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuthContext = () => {
  return useContext(AuthContext);
};

const PrivateRoute: FC<{ children: JSX.Element }> = ({ children }) => {
  const { user } = useAuthContext();
  const location = useLocation();

  // console.log(user);
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (user === null) {
  //     navigate("/login");
  //   }
  //   console.log("jancok", user);
  //   // eslint-disable-next-eslint
  // }, [navigate, user]);

  if (user === null) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export { useAuthContext, AuthProvider, PrivateRoute };
